/**
 * The built deck.
 *
 * The 3D stage and turntable are single, imperative objects created once at
 * boot. Rather than thread them through every component, they are installed
 * here and reached by the handful of modules that actually drive them.
 */

import type { Stage } from '../three/stage.ts';
import type { Turntable } from '../three/turntable.ts';

export interface Hardware {
  stage: Stage;
  tt: Turntable;
}

let installed: Hardware | null = null;

export function installHardware(hw: Hardware): void {
  installed = hw;
}

/** The deck. Throws before boot has finished building it. */
export function hardware(): Hardware {
  if (!installed) throw new Error('The deck has not been built yet.');
  return installed;
}

/** The deck, or null while the app is still booting. */
export const hardwareOrNull = (): Hardware | null => installed;
